import { observer } from 'mobx-react';
import React, { forwardRef } from 'react';

import type { AuthStoreType } from 'bz-stores/lib/auth-store';
import AuthStore, { AuthStoreMode } from 'bz-stores/lib/auth-store';

import SlideDialog from 'bz-core-controls/controls/modal/slide-dialog/internal';
import type { IProps as ISlideDialogProps } from 'bz-core-controls/controls/modal/slide-dialog/internal';

interface IProps extends Omit<ISlideDialogProps, 'classes'> {
  authStore?: AuthStoreType;
}

const SecureSlideDialog: React.FC<IProps> = observer(
  forwardRef((props, ref) => {
    const { className, ...slideDialogProps } = props;

    const classNames = React.useMemo(() => {
      const classNames = [];

      if (!!className) {
        classNames.push(className);
      }

      if (AuthStore && AuthStore.mode !== AuthStoreMode.none) {
        classNames.push('dialog-blur');
      }

      return classNames.join(' ');
    }, [className]);

    return (
      <SlideDialog
        ref={ref}
        {...slideDialogProps}
        disableEnforceFocus={true}
        className={classNames}
      >
        {props.children}
      </SlideDialog>
    );
  })
);

export default SecureSlideDialog;
